import React, { Component } from "react";
import {
    getObjectType,
    getMethodType,
    getMethodValue,
    getMethodDescription,
    getMethodMeasure,
    getContent,
    isSimilarObject
} from '../../helper';

export default class TradeObjectInfo extends Component {
    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const {
            objectIndex,
            object,
        } = this.props;

        return  (
                <ul key={'1'+objectIndex} className="examples__wrap examples__wrap-executor-wrap">
                    {getObjectType(object.order_position.order_object)}
                    {getMethodType(object.order_position)}
                    {getMethodValue(object.order_position.order_method)}
                    {getMethodDescription(object.order_position.order_method)}
                    {getMethodMeasure(object.order_position.order_method)}
                    {getContent(object.order_position.content)}
                </ul>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/TradeObjectInfo.js